import React, { useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Redirect, useLocation } from "react-router-dom";
import ReactGA from "react-ga";
// hash router ignores history
// import { createBrowserHistory } from "history";
import "basscss/css/basscss.min.css";

import "./styles/index.scss";
import App from "./App";
import { LoadingBar } from "./components";
import { DATA_FILES, urls } from "./utils";
import { useStore } from "./store";
import { setupWindow } from "./utils/ui";

// console.log("===========================================");
// console.log(`Using ${process.env.REACT_APP_USE_DATA_FORMAT} data`);
// console.log("===========================================");

// Set up analytics
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
setupWindow();

// export const history = createBrowserHistory();

const DataProvider = ({ render }) => {
  const initEventData = useStore(
    useCallback((state) => state.initEventData, [])
  );
  const initTargetOrderData = useStore(
    useCallback((state) => state.initTargetOrderData, [])
  );
  const initMediaData = useStore(
    useCallback((state) => state.initMediaData, [])
  );
  const initFinancialData = useStore(
    useCallback((state) => state.initFinancialData, [])
  );
  const initCorporateData = useStore(
    useCallback((state) => state.initCorporateData, [])
  );
  const eventData = useStore(useCallback((state) => state.data.events, []));
  const dispatch = useStore(useCallback((state) => state.dispatch, []));
  const ready = useStore(useCallback((state) => state.app.ready, []));

  useEffect(() => {
    if (ready) return;

    async function fetchAllData() {
      Promise.all([
        initEventData(DATA_FILES.EVENTS),
        initMediaData(DATA_FILES.MEDIA),
      ]).then(() => {
        // setTimeout(() => {
        dispatch({
          type: `APP_UPDATE`,
          payload: {
            ready: true,
          },
        });
        // }, 1000);
      });
      // await initEventData(DATA_FILES.EVENTS);
      // await initMediaData(DATA_FILES.MEDIA);
    }

    fetchAllData();
  }, [
    ready,
    dispatch,
    initMediaData,
    initCorporateData,
    initTargetOrderData,
    initEventData,
    initFinancialData,
  ]);
  // return null;
  return ready ? (
    render(eventData)
  ) : (
    <div className="full-width full-height flex flex-column  items-center justify-center center">
      <div>
        <h1>Loading...</h1>
      </div>
      <div className="lg-col-6 col-9">
        <LoadingBar />
      </div>
    </div>
  );
  // return eventData.length ? render(eventData) : <h1>Loading</h1>;
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    ReactGA.pageview(pathname, {
      debug: process.env.NODE_ENV === "development",
    });
    document.querySelector("#root").scrollTo(0, 0);
  }, [pathname]);

  return null;
}

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <Route exact path="/">
        <Redirect to={urls.root.path} />
      </Route>
      <ScrollToTop />
      <DataProvider render={(data) => <App data={data} />} />
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
